/**
 * CTAs tarjeta Oleum: bolsa → carrito; Comprar ahora → checkout (carrito completo).
 * Productos con varias variantes (p. ej. tamaño de envase) abren un selector antes de añadir.
 */
(function () {
  function cartAddUrl() {
    var base =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
      (window.routes && window.routes.cart_add_url) ||
      '/cart/add';
    return base.indexOf('.js') !== -1 ? base : base + '.js';
  }

  function checkoutUrl() {
    var base = (window.shopUrl || window.location.origin || '').replace(/\/$/, '');
    return (base + '/checkout').replace(/([^:]\/)\/+/g, '$1');
  }

  function parseVariantId(raw) {
    var n = Number(raw);
    if (!raw || !Number.isFinite(n) || n <= 0) return null;
    return n;
  }

  function humanizeCartError(data, fallback) {
    var desc = (data && (data.description || data.message)) || '';
    var text = String(desc || fallback || 'No se pudo añadir al carrito.');
    var lower = text.toLowerCase();
    if (/sold out|agotado|no longer available|insufficient|existencias|inventario/i.test(lower)) {
      return 'Este producto está agotado.';
    }
    if (/parameter missing or invalid:\s*items|cannot find variant|invalid.*items/i.test(lower)) {
      return 'No se pudo añadir. El producto puede estar agotado o la variante no es válida.';
    }
    return text;
  }

  function addVariantToCart(variantId, quantity) {
    var id = parseVariantId(variantId);
    if (!id) {
      return Promise.reject(new Error('Este producto no tiene una variante disponible.'));
    }

    // FormData (id+qty) da mejores mensajes de agotado que el payload JSON `items`.
    var body = new FormData();
    body.append('id', String(id));
    body.append('quantity', String(quantity || 1));

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && data.status && Number(data.status) >= 400)) {
          throw new Error(humanizeCartError(data, 'No se pudo añadir al carrito.'));
        }
        return data;
      });
    });
  }

  function notifyAdded() {
    var refresh =
      window.refreshOleumCartUI ||
      function () {
        return Promise.resolve();
      };
    refresh();
    if (typeof window.showCartToast === 'function') {
      window.showCartToast('¡Añadido a la bolsa!', 'success');
    }
  }

  function notifyError(err) {
    var msg = (err && err.message) || 'No se pudo añadir. Intenta de nuevo.';
    if (typeof window.showCartToast === 'function') {
      window.showCartToast(msg, 'error');
    }
  }

  /* —— Selector de variante (hoja inferior en mobile, modal centrado en desktop) —— */

  var SHEET_CSS =
    '.oleum-variant-sheet{position:fixed;inset:0;z-index:10070;width:100%;max-width:none;height:100%;max-height:none;margin:0;padding:0;border:0;background:rgb(14 28 23/.45)}' +
    '.oleum-variant-sheet::backdrop{background:transparent}' +
    '.oleum-variant-sheet__panel{position:absolute;left:0;right:0;bottom:0;max-height:88vh;overflow-y:auto;background:#fff;border-radius:20px 20px 0 0;' +
    'padding:20px 20px calc(20px + env(safe-area-inset-bottom,0px));box-shadow:0 -12px 40px rgb(14 28 23/.18);font-family:Barlow,sans-serif;color:var(--black-brand,#0e1c17);' +
    'transform:translateY(100%);transition:transform .28s cubic-bezier(.22,1,.36,1)}' +
    '.oleum-variant-sheet.is-open .oleum-variant-sheet__panel{transform:translateY(0)}' +
    '.oleum-variant-sheet__head{display:flex;align-items:center;gap:14px;padding-right:36px;margin-bottom:18px}' +
    '.oleum-variant-sheet__img{flex:0 0 64px;width:64px;height:64px;border-radius:12px;object-fit:cover;background:#f7f4eb}' +
    '.oleum-variant-sheet__title{margin:0 0 4px;font-size:16px;line-height:20px;font-weight:600}' +
    '.oleum-variant-sheet__price{margin:0;font-size:18px;line-height:22px;font-weight:700;color:var(--green-900,#0d4d27)}' +
    '.oleum-variant-sheet__close{position:absolute;top:14px;right:14px;width:36px;height:36px;border:0;border-radius:50%;background:#f3f1ea;color:inherit;font-size:22px;line-height:1;cursor:pointer}' +
    '.oleum-variant-sheet__label{margin:0 0 10px;font-size:14px;line-height:18px;font-weight:600}' +
    '.oleum-variant-sheet__options{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:20px}' +
    '.oleum-variant-sheet__opt{min-height:44px;padding:10px 16px;border:1.5px solid rgb(14 28 23/.2);border-radius:999px;background:#fff;color:inherit;font:600 15px/20px Barlow,sans-serif;cursor:pointer}' +
    '.oleum-variant-sheet__opt[aria-checked="true"]{border-color:var(--green-900,#0d4d27);background:var(--green-900,#0d4d27);color:#fff}' +
    '.oleum-variant-sheet__opt:disabled{opacity:.45;text-decoration:line-through;cursor:not-allowed}' +
    '.oleum-variant-sheet__confirm{display:flex;align-items:center;justify-content:center;width:100%;min-height:48px;border:0;border-radius:999px;' +
    'background:var(--green-900,#0d4d27);color:#fff;font:600 16px/20px Barlow,sans-serif;cursor:pointer}' +
    '.oleum-variant-sheet__confirm:disabled{opacity:.6;cursor:wait}' +
    '@media screen and (min-width:750px){.oleum-variant-sheet__panel{left:50%;right:auto;bottom:50%;width:min(92vw,440px);border-radius:20px;padding:24px;' +
    'transform:translate(-50%,calc(50% + 24px));opacity:0;transition:transform .24s ease,opacity .24s ease}' +
    '.oleum-variant-sheet.is-open .oleum-variant-sheet__panel{transform:translate(-50%,50%);opacity:1}}';

  var productCache = {};

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function sizedImage(src, width) {
    if (!src) return '';
    var url = typeof src === 'string' ? src : src.src || '';
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function productHandleFor(btn) {
    if (btn.dataset.productHandle) return btn.dataset.productHandle;
    var holder = btn.closest('[data-product-handle]');
    if (holder) return holder.getAttribute('data-product-handle');
    var card = btn.closest('.product-card-wrapper, .oleum-product-card, [data-oleum-cart-rec-card]');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('product');
          return res.json();
        })
        .catch(function (err) {
          delete productCache[handle];
          throw err;
        });
    }
    return productCache[handle];
  }

  /**
   * Resuelve null si el botón puede añadir directo (una sola variante o sin datos del producto);
   * si hay varias variantes, resuelve el JSON del producto para mostrar el selector.
   */
  function productNeedingChoice(btn) {
    if (btn.dataset.variantCount && Number(btn.dataset.variantCount) <= 1) return Promise.resolve(null);
    var handle = productHandleFor(btn);
    if (!handle) return Promise.resolve(null);
    return fetchProduct(handle)
      .then(function (product) {
        return product && product.variants && product.variants.length > 1 ? product : null;
      })
      .catch(function () {
        return null;
      });
  }

  function prefetchOnIntent(btn) {
    if (btn.dataset.variantCount && Number(btn.dataset.variantCount) <= 1) return;
    var prefetch = function () {
      var handle = productHandleFor(btn);
      if (handle) fetchProduct(handle).catch(function () {});
    };
    btn.addEventListener('pointerenter', prefetch, { once: true, passive: true });
    btn.addEventListener('touchstart', prefetch, { once: true, passive: true });
  }

  function optionLabel(product) {
    var opts = product.options || [];
    if (opts.length === 1) {
      var name = typeof opts[0] === 'string' ? opts[0] : opts[0] && opts[0].name;
      if (name && name !== 'Title') return name;
    }
    return 'Elige una opción';
  }

  function ensureSheetStyles() {
    if (document.getElementById('oleum-variant-sheet-css')) return;
    var style = document.createElement('style');
    style.id = 'oleum-variant-sheet-css';
    style.textContent = SHEET_CSS;
    document.head.appendChild(style);
  }

  /**
   * Abre el selector como <dialog> modal: queda en la capa superior del navegador,
   * por encima de la barra inferior y de otros diálogos abiertos (p. ej. el intersticial del carrito).
   */
  function openVariantSheet(product, preselectId, mode, onConfirm) {
    ensureSheetStyles();

    var variants = product.variants || [];
    var singleOption = (product.options || []).length === 1;
    var selected =
      variants.filter(function (v) {
        return String(v.id) === String(preselectId) && v.available;
      })[0] ||
      variants.filter(function (v) {
        return v.available;
      })[0] ||
      variants[0];

    var dialog = document.createElement('dialog');
    dialog.className = 'oleum-variant-sheet';
    dialog.setAttribute('aria-label', 'Elige una opción de ' + (product.title || 'producto'));

    var optionsHtml = variants
      .map(function (v) {
        var label = singleOption ? v.option1 || v.title : v.title;
        return (
          '<button type="button" class="oleum-variant-sheet__opt" role="radio" data-variant-id="' +
          v.id +
          '" aria-checked="' +
          (v === selected) +
          '"' +
          (v.available ? '' : ' disabled') +
          '>' +
          escapeHtml(label) +
          (v.available ? '' : ' · Agotado') +
          '</button>'
        );
      })
      .join('');

    var confirmText = mode === 'checkout' ? 'Comprar ahora' : 'Añadir a la bolsa';

    dialog.innerHTML =
      '<div class="oleum-variant-sheet__panel">' +
      '<button type="button" class="oleum-variant-sheet__close" data-sheet-close aria-label="Cerrar">&times;</button>' +
      '<div class="oleum-variant-sheet__head">' +
      '<img class="oleum-variant-sheet__img" alt="" width="64" height="64" data-sheet-img>' +
      '<div><p class="oleum-variant-sheet__title">' +
      escapeHtml(product.title) +
      '</p><p class="oleum-variant-sheet__price" data-sheet-price></p></div>' +
      '</div>' +
      '<p class="oleum-variant-sheet__label">' +
      escapeHtml(optionLabel(product)) +
      '</p>' +
      '<div class="oleum-variant-sheet__options" role="radiogroup">' +
      optionsHtml +
      '</div>' +
      '<button type="button" class="oleum-variant-sheet__confirm" data-sheet-confirm>' +
      confirmText +
      '</button>' +
      '</div>';

    var img = dialog.querySelector('[data-sheet-img]');
    var price = dialog.querySelector('[data-sheet-price]');
    var confirmBtn = dialog.querySelector('[data-sheet-confirm]');

    function paint() {
      price.textContent = selected ? formatMoney(selected.price) : '';
      var src = sizedImage((selected && selected.featured_image) || product.featured_image, 160);
      if (src) img.src = src;
      img.hidden = !src;
      confirmBtn.disabled = !(selected && selected.available);
    }

    function close() {
      dialog.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        if (dialog.open && typeof dialog.close === 'function') dialog.close();
        if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
      }, 260);
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-sheet-close]')) {
        close();
        return;
      }
      var opt = e.target.closest('.oleum-variant-sheet__opt');
      if (opt && !opt.disabled) {
        dialog.querySelectorAll('.oleum-variant-sheet__opt').forEach(function (o) {
          o.setAttribute('aria-checked', String(o === opt));
        });
        selected = variants.filter(function (v) {
          return String(v.id) === opt.getAttribute('data-variant-id');
        })[0];
        paint();
      }
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    confirmBtn.addEventListener('click', function () {
      if (!selected || confirmBtn.disabled) return;
      confirmBtn.disabled = true;
      onConfirm(selected.id)
        .then(function () {
          if (mode !== 'checkout') close();
        })
        .catch(function () {
          confirmBtn.disabled = false;
        });
    });

    paint();
    document.body.appendChild(dialog);
    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute('open', '');
      }
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      dialog.classList.add('is-open');
    });
  }

  function goToCheckoutWith(variantId) {
    return addVariantToCart(variantId, 1).then(function () {
      window.location.href = checkoutUrl();
    });
  }

  function addToBagWith(variantId) {
    return addVariantToCart(variantId, 1).then(function () {
      notifyAdded();
    });
  }

  /** Clic en un CTA de tarjeta: selector si hay variantes; si no, acción directa. */
  function runCardAction(btn, mode) {
    var action = mode === 'checkout' ? goToCheckoutWith : addToBagWith;
    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;
    return productNeedingChoice(btn)
      .then(function (product) {
        if (!product) {
          return action(variantId).then(function () {
            if (mode !== 'checkout') btn.disabled = false;
          });
        }
        btn.disabled = false;
        openVariantSheet(product, variantId, mode, function (chosenId) {
          return action(chosenId).catch(function (err) {
            notifyError(err);
            throw err;
          });
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        notifyError(err);
      });
  }

  function bindComprarAhora(root) {
    (root || document).querySelectorAll('[data-comprar-ahora]').forEach(function (el) {
      if (el.dataset.oleumCheckoutBound) return;
      var variantId = el.getAttribute('data-variant-id');
      if (!variantId) return;
      el.dataset.oleumCheckoutBound = '1';
      prefetchOnIntent(el);
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (el.disabled) return;
        runCardAction(el, 'checkout');
      });
    });
  }

  function bindAddBag(root) {
    var selector = '[data-oleum-add-bag], [data-favoritos-add-bag]';
    (root || document).querySelectorAll(selector).forEach(function (btn) {
      if (btn.dataset.oleumBagBound) return;
      btn.dataset.oleumBagBound = '1';
      prefetchOnIntent(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!btn.getAttribute('data-variant-id') || btn.disabled) return;
        runCardAction(btn, 'bag');
      });
    });
  }

  function init(root) {
    bindComprarAhora(root);
    bindAddBag(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  window.initOleumProductCardCtas = init;
  window.oleumAddVariantToCart = addVariantToCart;
})();
